import { useRoutePreload } from '../hooks/useRoutePreload';

/**
 * Componente que gestiona el preloading de rutas críticas
 * Se monta dentro del árbol de la aplicación para iniciar la precarga
 */
export const RoutePreloader = () => {
  useRoutePreload();
  return null; // <-- Este componente no renderiza nada
};
